<div class="weaveFormField weaveFormFieldRadio"
  [ngClass]="{'error': showError && data === '' && required}"
  >

  <div class="weaveRadioGroup">
    @if (label) {
      <label [innerHTML]="label"></label>
    }
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }

    <mat-radio-group
      [(ngModel)]="data"
      (change)="onChange($event)"
      [ngClass]="{'mat-radio-group-vertical' : showOptionsVertical}"
      [attr.name]="id"
      [required]="required">
      @for (radio of radioList; track radio) {
        <mat-radio-button [value]="radio.value">{{radio.label}}</mat-radio-button>
      }
    </mat-radio-group>
  </div>
  @if (showError && data === '' && required) {
    <div
      class="weaveFormField_error">
      {{message}} cannot be empty
    </div>
  }
</div>
